'use strict';
var parent = require('../../stable/symbol/iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/actual/symbol/iterator.js
// module id = 335
// module chunks = 0